module.exports = __webpack_public_path__ + "img/hope-land.e1371768.png";